export const capitalize = (text: string) =>
  text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();

export const capitalizeEachWord = (text: string) =>
  text.trim().split(" ").map(word => capitalize(word)).join(" ");
